import React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { useSearch } from '../../context/SearchContext';

interface SalesOrgCellProps {
  params: GridRenderCellParams;
}

const SalesOrgCell: React.FC<SalesOrgCellProps> = ({ params }) => {
  const { getSalesOrgName } = useSearch();

  return <>{getSalesOrgName(params.value)}</>;
};

export default SalesOrgCell;
